var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',{attrs:{"id":"iiotTimeOfOperationFinishSpan"}},[_vm._v(" "+_vm._s(_vm.tableItem.finished === '' ? _vm.$t('finishTime.inProgress') : _vm.tableItem.finished)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }